import whatInput from 'what-input';
import Messages from '../components/messages';
import Device from '../components/device';
import MessageBroker from "@bonprix/pattern-library/components/message-broker";

function updateInputMethod(newInputMethod) {
    const currentInputMethodType = Device.getCurrentInputMethodType();
    const newInputMethodType = Device.InputMethod.translateToInputMethodType(newInputMethod);
    if (currentInputMethodType !== newInputMethodType) {
        MessageBroker.publish(Messages.INPUT_METHOD.CHANGED, {
            from: currentInputMethodType.event,
            to: newInputMethodType.event
        });
    }
    if (newInputMethodType === Device.InputMethod.Type.TOUCH) {
        document.documentElement.classList.remove(Device.InputMethod.Type.MOUSE.css);
        document.documentElement.classList.add(Device.InputMethod.Type.TOUCH.css, 'was-touch');
    } else {
        document.documentElement.classList.add(Device.InputMethod.Type.MOUSE.css);
        document.documentElement.classList.remove(Device.InputMethod.Type.TOUCH.css);
    }
    Device.setCurrentInputMethodType(newInputMethodType);
}

// needed because in the app there is the bug FP-239, because of a rogue mouse-input event we defer the registration 
setTimeout(() => whatInput.registerOnChange(updateInputMethod, 'input'));

// fallback if whatInput does not recognize change of input method
// PP-889, RWD-1680: some touch devices have desktop user agents, so at the first touch interaction, the device must be updated
if (Device.isMouse()) {
    document.addEventListener('touchstart', () => updateInputMethod('touch'), {passive: true});
}
